export default {
  path: '/trainCamp',
  name: 'TrainCamp',
  redirect: '/trainCamp/list',
  component: () => import('@/components/layout'),
  meta: { requiresAuth: true },
  children: [
    {
      path: 'list',
      component: () => import('@/views/trainCamp'),
      meta: { requiresAuth: true }
    },
    {
      path: 'info',
      component: () => import('@/views/trainCamp/info'),
      meta: { requiresAuth: true }
    },
    {
      path: 'squadDetail',
      component: () => import('@/views/squad/Detail'),
      meta: { requiresAuth: true }
    },
    {
      path: 'setting',
      component: () => import('@/views/trainCamp/setting'),
      meta: { requiresAuth: true }
    },
  ]
}
